import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from '../../../../hooks';

// Dummy data
const note = [
    "Redemption is scheduled for November 30, 2022.",
    "Minimum points required for redemption is 2,000 points.",
    "Select nearest MTN Office location for delivery of redeemed voucher.",
    "Check order status to view update on delivery and pick up of voucher.",
    "Points and voucher are non-refundable once redeemed.",
  ];
  
  const tips = [
    "Promo starts from 1st to 30th Nov, 2022",
    "Winners will be notified via call from 0244300000",
    "This promo is exclusive on MyMTN App.",
  ];

const useMashupNWinHome = () => {
    const { themeContext, theme } = useTheme();
    const { activeTheme } = themeContext;
    const {
        selectedLoyaltyData,
    } = useLoyalty();
    const { promoData: { bannerImage, tailImage } = {} } = selectedLoyaltyData || {};
    const history = useHistory();

    let themeColor = "background";
    let background = theme.colors[themeContext.activeTheme][themeColor];

    return {
        background,
        history,
        bannerImage,
        tailImage,
        tips,
        note
    }
}

export default useMashupNWinHome